module.exports = (require("./helpers/browser/js-loader")(parcelRequire.resolve("fRQbC"))).then(() => parcelRequire('3I5wi'));